<template>
  <div class="icon-settings" :class="{ disabled: disabled }">
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings">
        <mask
          id="mask0_99_30"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect id="Bounding box" y="0.217041" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_99_30)">
          <path
            id="settings_2"
            d="M9.69225 21.717L9.3115 18.6708C9.04367 18.5811 8.769 18.4555 8.4875 18.294C8.20617 18.1324 7.95459 17.9593 7.73275 17.7748L4.9115 18.967L2.604 14.967L5.04425 13.1228C5.02125 12.9741 5.00492 12.8248 4.99525 12.6748C4.98559 12.5248 4.98075 12.3754 4.98075 12.2265C4.98075 12.0844 4.98559 11.9399 4.99525 11.793C5.00492 11.6462 5.02125 11.4856 5.04425 11.3113L2.604 9.46704L4.9115 5.48629L7.723 6.66904C7.96417 6.47804 8.22159 6.30337 8.49525 6.14504C8.76892 5.98671 9.03784 5.85946 9.302 5.76329L9.69225 2.71704H14.3078L14.6885 5.77279C14.9885 5.88179 15.2599 6.00904 15.5028 6.15454C15.7458 6.30004 15.991 6.47154 16.2385 6.66904L19.0885 5.48629L21.396 9.46704L18.9173 11.34C18.9531 11.5015 18.9727 11.6525 18.976 11.793C18.9792 11.9334 18.9808 12.0747 18.9808 12.217C18.9808 12.3529 18.9775 12.491 18.971 12.6315C18.9647 12.7719 18.9417 12.9325 18.902 13.1133L21.3615 14.967L19.0538 18.967L16.2385 17.765C15.991 17.9625 15.7384 18.1372 15.4808 18.289C15.2231 18.441 14.959 18.5651 14.6885 18.6613L14.3078 21.717H9.69225ZM11 20.217H12.9655L13.325 17.5383C13.8353 17.405 14.3017 17.2155 14.724 16.97C15.1465 16.7244 15.5539 16.4086 15.9463 16.0228L18.4308 17.067L19.4155 15.367L17.2463 13.7325C17.3296 13.4735 17.3863 13.2196 17.4163 12.9708C17.4464 12.7221 17.4615 12.4709 17.4615 12.217C17.4615 11.9567 17.4464 11.7055 17.4163 11.4633C17.3863 11.221 17.3296 10.9735 17.2463 10.7208L19.4345 9.06704L18.45 7.36704L15.9365 8.42654C15.6018 8.06887 15.2009 7.75288 14.7338 7.47854C14.2664 7.20421 13.7937 7.00996 13.3155 6.89579L13 4.21704H11.0155L10.6845 6.88629C10.1743 7.00679 9.70325 7.19137 9.27125 7.44004C8.83909 7.68887 8.42684 8.00937 8.0345 8.40154L5.55 7.36704L4.5655 9.06704L6.725 10.6765C6.64167 10.9139 6.58334 11.1607 6.55 11.417C6.51667 11.6734 6.5 11.9432 6.5 12.2265C6.5 12.4869 6.51667 12.742 6.55 12.992C6.58334 13.242 6.6385 13.4889 6.7155 13.7325L4.5655 15.367L5.55 17.067L8.025 16.017C8.4045 16.4067 8.81025 16.726 9.24225 16.9748C9.67442 17.2235 10.152 17.4145 10.675 17.5478L11 20.217ZM12.0115 15.217C12.8435 15.217 13.5515 14.925 14.1355 14.341C14.7195 13.757 15.0115 13.049 15.0115 12.217C15.0115 11.385 14.7195 10.677 14.1355 10.093C13.5515 9.50904 12.8435 9.21704 12.0115 9.21704C11.1692 9.21704 10.4586 9.50904 9.87975 10.093C9.30092 10.677 9.0115 11.385 9.0115 12.217C9.0115 13.049 9.30092 13.757 9.87975 14.341C10.4586 14.925 11.1692 15.217 12.0115 15.217Z"
            fill="green"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
export default defineComponent({
  name: 'IconSettings',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style>
.icon-settings {
  height: 24px;
  position: relative;
  width: 24px;
}

.icon-settings .img {
  height: 19px;
  left: 3px;
  position: absolute;
  top: 2px;
  width: 19px;
}

.icon-settings.disabled:hover {
  background-color: var(--app-dark);
  cursor: not-allowed;
}
.icon-settings.disabled:hover path {
  fill: white;
}
.icon-settings path {
  fill: white;
  transition: fill 0.3s ease;
}
.icon-settings:hover {
  background-color: #fff300;
}
.icon-settings:hover path {
  fill: black;
}
</style>
